(function() {
  function padLastRow(list) {
    list.querySelectorAll('.master-bmsm-placeholder').forEach(function(el) { el.remove(); });

    var buttons = Array.from(list.querySelectorAll('button'));
    if (buttons.length < 2) return;

    var firstTop = buttons[0].getBoundingClientRect().top;
    var perRow = 0;
    for (var i = 0; i < buttons.length; i++) {
      if (Math.abs(buttons[i].getBoundingClientRect().top - firstTop) > 2) break;
      perRow++;
    }

    if (perRow <= 1 || perRow >= buttons.length) return;

    var remainder = buttons.length % perRow;
    if (remainder === 0) return;

    var btnWidth = buttons[0].offsetWidth;
    var needed = perRow - remainder;
    for (var i = 0; i < needed; i++) {
      var ph = document.createElement('span');
      ph.className = 'master-bmsm-placeholder';
      ph.style.cssText = 'width:' + btnWidth + 'px;height:0;visibility:hidden;pointer-events:none;';
      list.appendChild(ph);
    }
  }

  function run() {
    document.querySelectorAll('.hdt-master-buy-more-save-more-section .hdt-popover-variant hdt-richlist, .hdt-master-buy-more-save-more-section .hdt-popover-variant .hdt-master-bmsm-block-container').forEach(padLastRow);
  }

  // Run once on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { requestAnimationFrame(run); });
  } else {
    requestAnimationFrame(run);
  }

  // Only re-run on resize
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 150);
  });
})();
